const topicTags = [
  { label: '顶流密会', heat: '980万', hot: true },
  { label: '偷税漏税', heat: '860万', hot: true },
  { label: '综艺对骂', heat: '740万', hot: true },
  { label: '数据造假', heat: '650万', hot: false },
  { label: '选角黑幕', heat: '580万', hot: true },
  { label: '演唱会假唱', heat: '520万', hot: false },
  { label: '网红翻车', heat: '490万', hot: false },
  { label: '饭圈乱象', heat: '430万', hot: false },
  { label: '私生饭跟踪', heat: '370万', hot: false },
  { label: '经纪公司内斗', heat: '320万', hot: false },
  { label: '片酬天价', heat: '280万', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">话题热榜</h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicTags.map((tag, i) => (
            <div
              key={i}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all ${
                tag.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200/50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {tag.hot && <i className="ri-fire-fill text-sm text-primary-500"></i>}
              <span className="text-sm font-medium whitespace-nowrap">#{tag.label}</span>
              <span className="text-xs opacity-60 whitespace-nowrap">{tag.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}